"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../../Utilities");
var ChoiceGroupOption_base_1 = require("./ChoiceGroupOption.base");
var ChoiceGroupOption_styles_1 = require("./ChoiceGroupOption.styles");
exports.ChoiceGroupOption = Utilities_1.styled(ChoiceGroupOption_base_1.ChoiceGroupOptionBase, ChoiceGroupOption_styles_1.getStyles, undefined, { scope: 'ChoiceGroupOption' });
//# sourceMappingURL=ChoiceGroupOption.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/ChoiceGroup/ChoiceGroupOption/ChoiceGroupOption.js
// module id = 777
// module chunks = 0